import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../../services/dialog.service';

@Component({
  selector: 'app-dialog-host',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dialog-host.component.html',
  styleUrl: './dialog-host.component.css'
})
export class DialogHostComponent {
  constructor(public dialogService: DialogService) {}

  close(result: boolean): void {
    this.dialogService.resolve(result);
  }
}
